import { ReactNode, useCallback } from 'react';

import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type ConversationTransferredProps = {
  entry: ConversationAuditLogEntry<
    'TRANSFER_INITIATED' | 'TRANSFER_FAILED' | 'TRANSFER_SUCCESSFUL'
  >;
};

export const ConversationTransferred = ({
  entry,
}: ConversationTransferredProps): JSX.Element | null => {
  const getText = useCallback((): string | ReactNode => {
    const destinationLabel = entry.destination_label || '';
    const destinationType = entry.destination_type?.toLowerCase();

    const authorName = getLogEntryAuthorName(entry);
    const authorLink = (
      <UserLink userId={entry.author.id}>{authorName}</UserLink>
    );

    switch (entry.activity_type) {
      case 'TRANSFER_INITIATED':
        return (
          <>
            {entry.transfer_type?.toLowerCase()} conversation transfer is
            initiated by agent {authorLink} to {destinationType}{' '}
            {destinationLabel}`
          </>
        );
      case 'TRANSFER_FAILED':
        return (
          <>
            conversation transfer to {destinationType} {destinationLabel} by
            agent {authorLink} failed with status &apos;{entry.reason}&apos;
          </>
        );
      case 'TRANSFER_SUCCESSFUL':
        return (
          <>
            conversation successfully transferred to {destinationType}{' '}
            {destinationLabel} by agent {authorLink}
          </>
        );
    }
  }, [entry]);

  // For queue TRANSFER_SUCCESSFUL is generated on start, which sends before TRANSFER_INITIATED.
  // In order to prevent a potential confusion prevent skip log.
  if (
    entry.destination_type === 'QUEUE' &&
    entry.activity_type === 'TRANSFER_INITIATED'
  ) {
    return null;
  }

  const text = getText();

  return <LogEntry entry={entry} text={text} />;
};
